module.exports = __webpack_public_path__ + "static/img/part-core-bg.ed320ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/part-core-bg.png
// module id = ywJj
// module chunks = 7